import type { ReactNode } from "react";
import { useUIStore } from "@app/store";
import {
  NotFoundPage,
  UnauthorizedPage,
  InternalServerErrorPage,
} from "@pages/errors";

/**
 * @description Error handler middleware
 * Displays error pages based on error status codes from the UI store
 * This is used to display custom errors pages due to the api responses errors like 404, 500, 401, 403, etc.
 */
export const ErrorRoutes = ({ children }: { children: ReactNode }) => {
  const { error } = useUIStore();

  if (error?.status) {
    switch (error.status) {
      case 404:
        return <NotFoundPage />;
      case 500:
        return <InternalServerErrorPage />;
      case 401:
        return <UnauthorizedPage />;
      case 403:
        // TODO: Import and use ForbiddenPage component when available
        return <UnauthorizedPage />;
      default:
        return <InternalServerErrorPage />;
    }
  }

  return <>{children}</>;
};
